import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../_services/token.service';

export const TokenGuard = () => {
  const service = inject(TokenService);
  const router = inject(Router);
  const token = service.getToken();
  if (token !== null) {
    router.navigateByUrl('/');
    return false;
  }
  return true;
};
